import LocalizedStrings from 'react-localization';
import * as localization from '../localization';

let strings = new LocalizedStrings(localization, { logsEnabled: false });

export default strings;
